import { Component, computed, inject, input, signal } from '@angular/core';
import {
  GcButtonComponent,
  IpoLanguageService,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { FULL_SIZE_IMAGE_OVERLAY_OPENED } from '../posthug-analytics/analytics-event-types';
import { AnalyticsService } from '../posthug-analytics/analytics.service';
import { SharedModule } from '../shared.module';

@Component({
  selector: 'app-image-instruction',
  imports: [SharedModule, IpoTranslatePipe, GcButtonComponent],
  templateUrl: './image-instruction.component.html',
  styleUrl: './image-instruction.component.scss',
})
export class ImageInstructionComponent {
  private readonly analyticsService = inject(AnalyticsService);
  private readonly languageService = inject(IpoLanguageService);

  imageUrl = input.required<string>();

  imgUrlByLanguage = computed(() =>
    this.imageUrl().replace(
      '{lang}',
      this.languageService.getStoredLanguage() as string,
    ),
  );

  readonly isShowingFullSizeImageOverlay = signal(false);

  openFullSizeImageOverlay() {
    this.isShowingFullSizeImageOverlay.set(true);
    this.analyticsService.logEvent(FULL_SIZE_IMAGE_OVERLAY_OPENED, {
      eventType: this.imgUrlByLanguage(),
    });
  }

  closeFullSizeImageOverlay() {
    this.isShowingFullSizeImageOverlay.set(false);
  }
}
